import actionTypes from './actionTypes'

const quickLaunchActions = {

	createDrawItLessonSuccess: payload => ({
		type: actionTypes.QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_SUCCESS,
		drawItUID: payload.slideId,
		params: {},
	}),
	createDrawItLessonFailed: serverError => ({
		type: actionTypes.QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_FAILED,
		serverError,
	}),
	createOeqLessonSuccess: payload => ({
		type: actionTypes.QUICK_LAUNCH_OEQ_CREATE_LESSON_SUCCESS,
		oeqUID: payload.slideId,
		params: {},
	}),
	createOeqLessonFailed: serverError => ({
		type: actionTypes.QUICK_LAUNCH_OEQ_CREATE_LESSON_FAILED,
		serverError,
	}),
	createCollaborateLessonSuccess: payload => ({
		type: actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_SUCCESS,
		presentationId: payload.presentationId,
		presentationUid: payload.presentationUid,
		appUid: payload.appUid,
	}),
	createCollaborateLessonFailed: serverError => ({
		type: actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_FAILED,
		serverError,
	}),
	createCollaborateActivitySaveSuccess: () => ({
		type: actionTypes.QUICK_LAUNCH_COLLABORATE_SAVE_ACTIVITY_SUCCESS,
	}),
	createCollaborateActivityCancel: () => ({
		type: actionTypes.QUICK_LAUNCH_COLLABORATE_CANCEL_ACTIVITY,
	}),
	createDrawIt() {
		return {
			type: actionTypes.QUICK_LAUNCH_CREATE_DRAW_IT,
		}
	},
	createOeq() {
		return {
			type: actionTypes.QUICK_LAUNCH_CREATE_OEQ,
		}
	},
	createCollaborate() {
		return {
			type: actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE,
		}
	},
	createTimer() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_CREATE,
		}
	},
	quickLaunchLessonSuccess: (payload, presentation_uid) => ({
		type: actionTypes.QUICK_LAUNCH_LAUNCH_LESSON_SUCCESS,
		payload,
		presentation_uid,
	}),
	quickLaunchLessonFailed: error => ({
		type: actionTypes.QUICK_LAUNCH_LAUNCH_LESSON_FAILED,
		error,
	}),
	retryLaunch() {
		return {
			type: actionTypes.QUICK_LAUNCH_RETRY_LAUNCH,
		}
	},
	cancelLaunch() {
		return {
			type: actionTypes.QUICK_LAUNCH_CANCEL_LAUNCH,
		}
	},
	timerCreateSave(time) {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_CREATE_SAVE,
			time,
		}
	},
	timerCreateCancel() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_CREATE_CANCEL,
		}
	},
	timerCancelPill() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_CANCEL_PILL,
		}
	},
	timerCancelCountdown() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_CANCEL_COUNTDOWN,
		}
	},
	timerRestart() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_RESTART,
		}
	},
	timerResume() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_RESUME,
		}
	},
	timerPause() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_PAUSE,
		}
	},
	addTime() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_ADD_TIME,
		}
	},
	removeTime() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_REMOVE_TIME,
		}
	},
	timerCountdownStart(time) {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_COUNTDOWN_START,
			time,
		}
	},
}

export default quickLaunchActions
